import { Link } from 'react-router-dom';
import { DocumentMeta } from '@/gateway/DocumentMeta';
import { AuroraBackdrop } from './auth/AuroraBackdrop';
import { AuthHeadline } from './auth/AuthHeadline';
import { AuthRouteTransition } from './auth/AuthRouteTransition';

/**
 * Layout for public auth pages (login, signup, verify-otp, invite preview).
 * Two-column hero: informative panel (left) + form card (right) with
 * route-aware transitions on both sides.
 */
export function AuthShell() {
  return (
    <div className="relative grid min-h-screen w-full bg-[rgb(var(--background))] p-4 lg:grid-cols-2 lg:p-8">
      {/* No app owns these pages — reset the tab to the generic Clarix brand.
          A client-side bounce here (e.g. an expired session on /crm landing on
          /login) never re-runs index.html's boot script, so without this the
          tab keeps the previous app's name and favicon. */}
      <DocumentMeta />
      <AuroraBackdrop />
      {/* Left — informative panel (hidden on mobile) */}
      <div className="relative z-10 hidden flex-col justify-center pl-48 lg:flex">
        <AuthHeadline />
      </div>

      {/* Right — form card with route transition */}
      <div className="relative z-10 flex items-center justify-center px-4 py-8 lg:px-6 lg:py-12">
        <div className="w-full max-w-md">
          <Link
            to="/"
            className="mb-6 inline-block text-5xl font-bold text-slate-900 lg:hidden dark:text-slate-100"
          >
            Clarix
          </Link>
          <div className="rounded-2xl border border-[rgb(var(--border))] bg-[rgb(var(--surface))] p-8 shadow-xl">
            <AuthRouteTransition />
          </div>
          <p className="mt-6 text-center text-lg text-slate-500">
            Workspace-based platform. Sign in to access your workspace, or create one.
          </p>
        </div>
      </div>
    </div>
  );
}
